import React from 'react';
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import { SectionHeading } from "components/misc/Headings.js";

import defaultCardImage from "../../images/shield-icon.svg";

import { ReactComponent as SvgDecoratorBlob3 } from "../../images/svg-decorator-blob-3.svg";

import SupportIconImage from "../../images/support-icon.svg";

import ReliableIconImage from "../../images/reliable-icon.svg";
import { useNavigate } from 'react-router-dom';
import Brain from "../../images/brain.svg"
import Health from "../../images/health.svg"
import PC from "../../images/pc.svg"
import Talk from "../../images/talk.svg"

const Container = styled.div`
  ${tw`relative rounded-4xl`}
  background-color: #FAF6F3;
`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto py-20 md:py-24 px-4`}
`;
const Heading = tw(SectionHeading)`w-full`;
const Intro = tw.p`w-full mt-4 text-center text-secondary-100 font-medium`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 px-4 flex`}
`;

const Card = styled.button`
  ${tw`flex flex-col w-full mx-auto max-w-sm items-start text-left px-8 py-10 bg-white rounded-3xl mt-8 shadow-md
    transition duration-300 focus:outline-none`}
  border: 1px solid #F3EBE6;

  &:hover, &:focus-visible {
    ${tw`shadow-xl`}
    transform: translateY(-4px);
  }

  .imageContainer {
    ${tw`rounded-2xl p-4 flex-shrink-0`}
    background-color: #EFE7FF;
    img {
      ${tw`w-8 h-8`}
    }
  }

  .title {
    ${tw`mt-6 font-bold text-xl leading-none text-secondary-500`}
  }

  .description {
    ${tw`mt-3 font-medium text-secondary-100 text-sm leading-relaxed flex-1`}
  }

  .more {
    ${tw`mt-6 text-sm font-bold text-primary-500`}
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;

export default () => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component):
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */
 
 

  const cards = [

    { imageSrc: SupportIconImage, title: "Intake", url: "/contact", description: "Dit is een kennismakingsgesprek van 90 minuten waarin het gaat over wie jij bent, wat je klachten zijn en waar je graag bij geholpen wilt worden (de hulpvraag). Aan het eind van de intake wordt besproken of je op je plek zit, wat we gaan doen, en hoe dit er de komende tijd uit gaat zien." },
    { imageSrc: Talk, title: "Therapie", url: "/therapie", description: " In een tiental gesprekken van doorgaans 60 minuten behandelen we de klachten waarvoor je bent aangemeld. Binnen mijn praktijk kan dit door middel van cognitieve gedragstherapie, traumatherapie, psychotherapie en/of schrijftherapie." },
    { imageSrc: Brain, title: "Onderzoek", url: "/onderzoek", description: "Dit zijn een aantal afspraken waarin wordt getest of er sprake is van een diagnose zoals ADHD of autisme. Dit kan door middel van een interview, vragenlijsten en/of cognitieve taken. Daarnaast wordt meestal een persoon, die jou van jongs af aan kent, betrokken bij het onderzoek.    " },
    { imageSrc: PC, title: "Op locatie en online", url: "/vragen", description: "Voor therapie kun je bij mij zowel op locatie als online terecht. Daarnaast krijg je Therapieland wat een app is met online modules. Beide manieren blijken effectief als het gaat om het behandelen van mentale klachten. Doe dus vooral wat voor jou goed voelt." },
    { imageSrc: Health, title: "Verzekerde zorg",  url: "/vragen", description: "Ben je boven de 18 jaar en heb je een verwijsbrief van de huisarts? Dan wordt de zorg (deels) vergoed. Check dit altijd eerst bij jouw zorgverzekeraar. Is dit toch niet het geval? Ook dan kan je bij mij terecht." },
       {
      imageSrc: ReliableIconImage,
      title: "Samen Beslissen",
          description: "Jij bent de expert over jouw binnenwereld. Daarom maken we belangrijke beslissingen die over jou gaan samen.",
      url: "/vragen"
    },
  ];

  const navigate = useNavigate();

  const handleClick = (url) => {
    window.scrollTo(0, 0);
    navigate(url);
  };

  return (
    <Container id="wat-doe-ik">
      <ThreeColumnContainer>
        <Heading><span tw="text-primary-500">Wat</span> doe ik?</Heading>
        <Intro>Van kennismaking tot behandeling: dit kun je van mij verwachten.</Intro>
        {cards.map((card, i) => (
          <Column key={i}>
            <Card type="button" onClick={() => handleClick(card.url)}>
              <span className="imageContainer">
                <img src={card.imageSrc || defaultCardImage} alt="" />
              </span>
              <span className="title">{card.title}</span>
              <span className="description">{card.description}</span>
              <span className="more">Lees meer →</span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
      <DecoratorBlob />
    </Container>
  );
};
